import React from 'react';

import { CustomIconProps } from '../../src/utils/interfaces/Icon';

const ReceiptItem: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.3346 6.49169C18.3427 6.54974 18.3427 6.60864 18.3346 6.66669V13.3334C18.3344 13.481 18.2949 13.626 18.2202 13.7534C18.1455 13.8807 18.0384 13.986 17.9096 14.0584L10.4096 18.225L10.293 18.275H10.2096C10.0727 18.3083 9.92987 18.3083 9.79297 18.275H9.70964C9.67201 18.2619 9.63574 18.2451 9.6013 18.225L2.1013 14.0584C1.97103 13.9871 1.86216 13.8823 1.78598 13.7548C1.70979 13.6274 1.66905 13.4819 1.66797 13.3334V6.66669C1.70436 6.60037 1.75234 6.5411 1.80964 6.49169C1.80497 6.46411 1.80497 6.43594 1.80964 6.40836C1.82119 6.36747 1.838 6.32826 1.85964 6.29169C1.87711 6.26043 1.89964 6.23227 1.9263 6.20836C1.94073 6.17489 1.96043 6.14394 1.98464 6.11669L2.0763 6.05002L2.1513 5.99169L9.6513 1.82502C9.77798 1.75188 9.92169 1.71338 10.068 1.71338C10.2142 1.71338 10.358 1.75188 10.4846 1.82502L17.9846 5.99169L18.0846 6.06669L18.1513 6.11669L18.2346 6.22502C18.2515 6.24526 18.2655 6.26769 18.2763 6.29169C18.3007 6.33378 18.3203 6.37851 18.3346 6.42502V6.49169ZM4.21797 6.66669L10.0013 9.89169L12.2096 8.65003L6.51797 5.40002L4.21797 6.66669ZM15.7846 6.66669L10.0013 3.45836L8.2263 4.45002L13.918 7.70836L15.7846 6.66669ZM9.16797 11.35L3.33464 8.08336V12.8417L9.16797 16.0834V11.35ZM10.8346 11.35V16.0834L16.668 12.8417V8.09169L15.0013 9.01669L13.3346 9.95003L10.8346 11.35Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ReceiptItem;
